// dev: {
//   admin: 'https://skordev.com/admin-dashboard/#/report',
//   app: 'https://skordev.com/',
//   basePath: 'https://bstl-pwa.skordev.com/#/',
//   img: 'https://skordev.com',
// },
// Config servers from UI to ease QA testing
// url.admin = dev.admin - Admin URL: no changes
// url.app = dev.app - API server: override from cookie if exists
// url.img = dev.img - Image server: override from cookie if exists

import PWA from './white-labelling';

// on UAT, it does not make sense to show the server config panel, then make isUAT = true;
const isUAT = false;

const API_URL_KEY = 'app_cfg_api';
const IMG_URL_KEY = 'app_cfg_img';

type CookieOpts = {
  days?: number; // default 1
  path?: string; // default '/'
  sameSite?: 'Lax' | 'Strict' | 'None'; // default 'Lax'
  secure?: boolean; // default true
  // omit "domain" to keep it host-only (safest)
};

function setCookie(name: string, value: string, opts: CookieOpts = {}) {
  const { days = 1, path = '/', sameSite = 'Lax', secure = true } = opts;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  let cookie = `${name}=${encodeURIComponent(value)}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += '; Secure';
  document.cookie = cookie;
}

function getCookie(name: string): string | null {
  const m = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') +
        '=([^;]*)',
    ),
  );
  return m ? decodeURIComponent(m[1]) : null;
}

function deleteCookie(name: string) {
  document.cookie = `${name}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
}

export function mountConfigPanel() {
  const domains = [
    'skordev.com',
    'ankit.skordev.com',
    'akshay.skordev.com',
    'amolc.skordev.com',
    'ashutosh.skordev.com',
    'deepika.skordev.com',
    'dryice.skordev.com',
    'govind.skordev.com',
    'graviton.skordev.com',
    'jack.skordev.com',
    'jerry.skordev.com',
    'mamatha.skordev.com',
    'mario.skordev.com',
    'myaia.skordev.com',
    'nuhs.skordev.com',
    'piklu.skordev.com',
    'prashant.skordev.com',
    'prateek.skordev.com',
    'raghavendra.skordev.com',
    'rishi.skordev.com',
    'shashi.skordev.com',
    'siva.skordev.com',
    'suraj.skordev.com',
    'surya.skordev.com',
    'tom.skordev.com',
    'utsav.skordev.com',
    'vineet.skordev.com',
    'yoseph.skordev.com',
  ];

  const root = document.createElement('div');
  root.style.position = 'fixed';
  root.style.top = '16px';
  root.style.left = '16px';
  root.style.zIndex = '99999';
  root.innerHTML = `
    <button id="cfg-toggle" style="padding:8px 12px;border:1px solid #ccc;border-radius:8px;background:#fff;cursor:pointer;">
      ⚙️
    </button>
    <div id="cfg-panel" style="display:none;margin-top:8px;padding:12px;width:320px;border:1px solid #ddd;border-radius:12px;background:#fff;box-shadow:0 8px 24px rgba(0,0,0,.12);">
      <label style="display:block;margin-bottom:8px;font:600 12px system-ui">Server</label>
      <select id="cfg-domain" style="width:100%;padding:8px;border:1px solid #ccc;border-radius:8px;margin-bottom:12px">
        ${domains.map((d) => `<option value="${d}">${d}</option>`).join('')}
      </select>

      <div style="display:flex;gap:8px;margin-top:12px">
        <button id="cfg-save" style="flex:1;padding:8px;border:0;border-radius:8px;background:#0ea5e9;color:#fff;cursor:pointer">Save</button>
        <button id="cfg-reset" style="padding:8px;border:1px solid #ccc;border-radius:8px;background:#fff;cursor:pointer">Reset</button>
      </div>

    </div>
  `;
  document.body.appendChild(root);

  const $toggle = root.querySelector<HTMLButtonElement>('#cfg-toggle')!;
  const $panel = root.querySelector<HTMLDivElement>('#cfg-panel')!;
  const $domain = root.querySelector<HTMLSelectElement>('#cfg-domain')!;
  const $save = root.querySelector<HTMLButtonElement>('#cfg-save')!;
  const $reset = root.querySelector<HTMLButtonElement>('#cfg-reset')!;

  const domain = getCookie(IMG_URL_KEY);
  if (domain) {
    $domain.value = domain.replace('https://', '');
  } else {
    $domain.value = PWA.servers.dev.img.replace('https://', '');
  }
  $toggle.innerHTML = '⚙️ ' + $domain.value;

  $toggle.onclick = () => {
    $panel.style.display = $panel.style.display === 'none' ? '' : 'none';
  };
  $reset.onclick = () => {
    deleteCookie(API_URL_KEY);
    deleteCookie(IMG_URL_KEY);

    window.location.reload();
  };

  $save.onclick = () => {
    const domain = $domain.value;
    setCookie(API_URL_KEY, `https://${domain}/`);
    setCookie(IMG_URL_KEY, `https://${domain}`);
    window.location.reload();
  };

  window.setTimeout(() => {
    root.remove();
  }, 10000);
}

// Load only on the Login Page
if (window.location.hash.startsWith('#/login') && !isUAT) {
  if (
    document.readyState === 'interactive' ||
    document.readyState === 'complete'
  ) {
    mountConfigPanel();
  } else {
    document.addEventListener('DOMContentLoaded', () => mountConfigPanel());
  }
}

// Environment URLs
const url = PWA.servers.dev;

url.app = getCookie(API_URL_KEY) ?? url.app;
url.img = getCookie(IMG_URL_KEY) ?? url.img;

export const environment = {
  production: false,
  components: PWA.components,
  settings: PWA.settings,
  url,
};
